import { LowOpacityButton } from "@alch/ui";
import { LayoutLeft } from "@alch/ui/icons/16";
import { MessageChat01 } from "@alch/ui/icons/20";
import clsx from "clsx";
import { HoverCard } from "radix-ui";
import { useState } from "react";
import { useLayoutContext } from "../LayoutContext";
import FeedbackModal from "./FeedbackModal";
import { buttonClassName, iconClassName } from "./NavButton";
import NavHoverCard, { COMMON_HOVER_CARD_PROPS } from "./NavHoverCard";

interface NavFooterProps {
  onHideOverlay?: () => void;
  compact?: boolean;
}

const NavFooter = ({ onHideOverlay, compact }: NavFooterProps) => {
  const [isFeedbackModalOpen, setIsFeedbackModalOpen] = useState(false);
  const { setIsNavExpanded, isNavExpanded } = useLayoutContext();

  return (
    <footer
      className={clsx(
        "relative z-20 flex flex-col gap-2 p-4 pt-0",
        compact ? "px-3" : "",
      )}
    >
      {onHideOverlay ? null : (
        <HoverCard.Root
          key={String(compact)}
          {...COMMON_HOVER_CARD_PROPS}
          openDelay={150}
        >
          <HoverCard.Trigger asChild>
            <button
              className={clsx(buttonClassName, "ml-auto max-w-fit")}
              onClick={() => setIsNavExpanded(!isNavExpanded)}
            >
              <LayoutLeft className={iconClassName} />
            </button>
          </HoverCard.Trigger>

          {compact && <NavHoverCard title="Expand" />}
        </HoverCard.Root>
      )}

      <HoverCard.Root {...COMMON_HOVER_CARD_PROPS}>
        <HoverCard.Trigger asChild>
          <LowOpacityButton
            icon={<MessageChat01 />}
            className="light flex w-full justify-center overflow-hidden rounded-sm whitespace-nowrap"
            onClick={() => setIsFeedbackModalOpen(true)}
          >
            {compact ? "" : "Share feedback"}
          </LowOpacityButton>
        </HoverCard.Trigger>

        {compact ? <NavHoverCard title="Share feedback" /> : null}
      </HoverCard.Root>

      <FeedbackModal
        isOpen={isFeedbackModalOpen}
        onClose={() => {
          setIsFeedbackModalOpen(false);
          onHideOverlay?.();
        }}
      />
    </footer>
  );
};

export default NavFooter;
